module.exports = __webpack_public_path__ + "static/logo-starship-a4e378fd22dc7dbb6bacbd059685052c.png";